export default __webpack_public_path__ + "89f1b2234b00598a543a1873ac5fd12f.png";